var _a;
const initBlockVideo = () => {
    const runVideo = document.querySelector('.js-run-video');
    runVideo && runVideo.addEventListener('click', (e) => {
        e.preventDefault();
        const block = runVideo.closest('.block-video');
        const overlay = block === null || block === void 0 ? void 0 : block.querySelector('.block-video__overlay');
        const video = block === null || block === void 0 ? void 0 : block.querySelector('video');
        if (video) {
            video.play();
            video.addEventListener('ended', () => {
                if (overlay) {
                    overlay.classList.remove('hidden-tag');
                }
            }, false);
        }
        if (overlay) {
            overlay.classList.add('hidden-tag');
        }
    });
};
document.addEventListener('DOMContentLoaded', initBlockVideo, false);
if (window.acf) {
    (_a = window.acf) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlockVideo);
}
export {};
